export default __webpack_public_path__ + "img/319dd55f82fd30c48cf81ddc2ad45086.svg";